import GoDocsPage from 'pages/Loan/GoDocs'

export default function GoDocsClosingScreen() {
  return <GoDocsPage hasOverview={false} />
}
